import { BaseModel } from "@blue-chip/core";

export default class ProjectCategoryPrice extends BaseModel {}
